import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-120d3db8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-service-search" }

import { computed, PropType, ref } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import BaseAutocomplete from '@/components/BaseAutocomplete.vue'
import { debounce } from 'lodash'
import { Option } from '@/models/shared.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteServiceSearch',
  props: {
  services: {
    type: Array as PropType<PublicService[]>,
    required: true,
  },
},
  emits: ['onSelect', 'onSearchChange'],
  setup(__props, { emit: emits }) {

const props = __props





const searchValue = ref('')

const debouncedSearchChange = debounce((value: string) => {
  emits('onSearchChange', value)
}, 400)

const options = computed<Option[]>(() =>
  props.services.map((service) => ({
    key: service.id,
    label: `${service.name} (${service.company_name})`,
  })),
)

const handleSearchChange = () => {
  debouncedSearchChange(searchValue.value)
}

const handleSelect = async (option: Option) => {
  const selectedService = props.services.find(
    (service) => service.id === option.key,
  )
  if (selectedService) {
    emits('onSelect', selectedService)
    searchValue.value = ''
    emits('onSearchChange', '')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseAutocomplete, {
      modelValue: searchValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        handleSearchChange
      ],
      options: _unref(options),
      "no-options-label": _ctx.$t('noResults'),
      placeholder: 'Otsi',
      name: "clientFinder",
      "icon-left": "magnifying-glass",
      "disable-filtering": true,
      "close-on-select": true,
      onKeyup: handleSearchChange,
      onOptionClick: _cache[1] || (_cache[1] = (value) => handleSelect(value))
    }, null, 8, ["modelValue", "options", "no-options-label"])
  ]))
}
}

})